import { PLAN_METADATA_CATEGORY_ICONS } from "./planMetadataCategoryIcons"

/** Metadata accordion tabs (form + live preview). */
export const PLAN_METADATA_SECTIONS = [
  {
    key: "feature_access",
    labelKey: "tab_feature_access",
    Icon: PLAN_METADATA_CATEGORY_ICONS.feature_access,
  },
  {
    key: "furniture_tools",
    labelKey: "tab_furniture_tools",
    Icon: PLAN_METADATA_CATEGORY_ICONS.furniture_tools,
  },
  {
    key: "ai_image_tools",
    labelKey: "tab_ai_image_tools",
    Icon: PLAN_METADATA_CATEGORY_ICONS.ai_image_tools,
  },
  {
    key: "room_planner",
    labelKey: "tab_room_planner",
    Icon: PLAN_METADATA_CATEGORY_ICONS.room_planner,
  },
  {
    key: "advanced_spaces",
    labelKey: "tab_advanced_spaces",
    Icon: PLAN_METADATA_CATEGORY_ICONS.advanced_spaces,
  },
  {
    key: "upcoming_features",
    labelKey: "tab_upcoming_features",
    Icon: PLAN_METADATA_CATEGORY_ICONS.upcoming_features,
  },
]

export const PLAN_METADATA_SECTION_LABEL_KEYS = Object.fromEntries(
  PLAN_METADATA_SECTIONS.map(({ key, labelKey }) => [key, labelKey])
)
